// extracted by mini-css-extract-plugin
export var container = "T_k";
export var content = "T_bY";
export var icon = "T_bz";
export var iconContainer = "T_bP";
export var icons = "T_bS";
export var image = "T_d";
export var label = "T_cy";
export var section = "T_b";
export var text = "T_cq";
export var title = "T_f";